import { useState, useCallback, useEffect, useRef } from "react";
import { Header } from "../../../common/Header/Header.jsx";
import { yupResolver } from "@hookform/resolvers/yup";
import * as schemas from "../../../../assets/schemas/schemas.js";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import {
  EditExternalProviderForm,
  EditInternalProviderForm,
  EditVehicularAssetForm,
} from "../../../common/Forms/Form.jsx";
import { filterOptionById, isCraneVehicleClass } from "../../../../assets/helpers/funciones.js"
import { statesService } from "../../../../services/statesService.js";
import { providersService } from "../../../../services/providersService.js";
import { vehicleService } from "../../../../services/vehicleService.js";
import { notify } from "../../../../assets/helpers/toast.js";
import { prodiverStatys, craneTypeOptions } from "../../../../assets/helpers/options.js";
import { LoadSpinner } from "../../../common/LoadSpinner/LoadSpinner";
import { useDropzone } from "react-dropzone";
import { vehicularAssetsService } from "../../../../services/vehicularAssetsService.js";
import "./EditProvider.scss";

export const EditExternalProvider = () => {
  let history = useHistory();
  let { providerId } = useParams();
  const { t } = useTranslation();
  const [statesOptions, setStatesOptions] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [isLoading, setIsloading] = useState(true);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.CreateProviderSchema(t)),
  });

  const onSubmit = handleSubmit(async (data) => {
    if (!isLoading) {
      setIsloading(true);
      providersService
        .editProvider(data, providerId)
        .then((response) => {
          if (response.status === 200) {
            notify(`Proveedor externo editado con éxito`, "success");
            history.push("/providers/external");
            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getStates = () => {
    statesService
      .getStates()
      .then((response) => {
        if (response.status === 200) {
          setStatesOptions(response?.data?.states);
          getProvidersById(providerId);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const getCities = async (cityId) => {
    if (!cityId) return
    statesService
      .getCities(cityId)
      .then((response) => {
        if (response.status === 200) {
          setCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
    return true;
  };


  const getProvidersById = (providerId) => {
    setIsloading(true);
    providersService
      .getProvidersById(providerId)
      .then((response) => {
        if (response.status === 200) {
          setValue("companyName", response?.data?.provider?.companyName);
          setValue("contactName", response?.data?.provider?.contactName);
          setValue("identification", response?.data?.provider?.identification);
          setValue(
            "identificationType",
            response?.data?.provider?.identificationType
          );
          setValue("phoneNumber", response?.data?.provider?.phoneNumber);
          setValue("phonePrefix", response?.data?.provider?.phonePrefix);
          setValue("state", response?.data?.provider?.state);
          setValue("type", response?.data?.provider?.type);
          setValue("isActive", response?.data?.provider?.isActive);
          setValue("isInternal", response?.data?.provider?.isInternal);
          setIsloading(false);

          getCities(response?.data?.provider?.state);
          setTimeout(() => {
            setValue("city", response?.data?.provider?.city);
          }, 1500);
        } else {
          notify(`${response.message}` || "error", "error");
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  };

  const cancelEdition = () => {
    history.push("/providers/external");
  };

  useState(() => {
    getStates();
  }, []);

  return (
    <>
      <Header />
      <LoadSpinner label={""} show={isLoading} />
      <div className="container">
        <div className="card incidence-card">
          <div style={{ margin: "0px" }} className="buttons-container">
            <h2 style={{ margin: "0px" }}>Editar Proveedor Externo</h2>
          </div>
          <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
          <EditExternalProviderForm
            t={t}
            register={register}
            errors={errors}
            watch={watch}
            action={onSubmit}
            cancel={cancelEdition}
            options={{ statesOptions: statesOptions, citiesOptions: citiesOptions, prodiverStatys: prodiverStatys }}
            onChange={{ getCities: getCities }}
          />
        </div>
      </div>
    </>
  );
};

export const EditInternalProvider = () => {
  let history = useHistory();
  let { providerId } = useParams();
  const { t } = useTranslation();
  const [statesOptions, setStatesOptions] = useState([]);
  const [isLoading, setIsloading] = useState(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.NewInternalProviderSchema(t)),
  });

  const onSubmit = handleSubmit(async (data) => {
    if (!isLoading) {
      setIsloading(true);
      providersService
        .editProvider(data, providerId)
        .then((response) => {
          if (response.status === 200) {
            notify(`Proveedor interno editado con éxito`, "success");
            history.push("/fleet/internal");
            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getStates = () => {
    statesService
      .getStates()
      .then((response) => {
        if (response.status === 200) {
          setStatesOptions(response?.data?.states);
          getProvidersById(providerId);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const getProvidersById = (providerId) => {
    setIsloading(true);
    providersService
      .getProvidersById(providerId)
      .then((response) => {
        if (response.status === 200) {
          setValue("companyName", response?.data?.provider?.companyName);
          setValue("contactName", response?.data?.provider?.contactName);
          setValue("identification", response?.data?.provider?.identification);
          setValue(
            "identificationType",
            response?.data?.provider?.identificationType
          );
          setValue("phoneNumber", response?.data?.provider?.phoneNumber);
          setValue("phonePrefix", response?.data?.provider?.phonePrefix);
          setValue("state", response?.data?.provider?.state);
          setValue("type", response?.data?.provider?.type);
          setValue("isActive", response?.data?.provider?.isActive);
          setValue("isInternal", response?.data?.provider?.isInternal);
          setIsloading(false);
        } else {
          notify(`${response.message}` || "error", "error");
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  };

  const cancelEdition = () => {
    history.push("/fleet/internal");
  };

  useState(() => {
    getStates();
  }, []);

  return (
    <>
      <Header />
      <LoadSpinner label={""} show={isLoading} />
      <div className="container">
        <div className="card incidence-card">
          <div style={{ margin: "0px" }} className="buttons-container">
            <h2 style={{ margin: "0px" }}>Editar Chofer</h2>
          </div>
          <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
          <EditInternalProviderForm
            t={t}
            register={register}
            errors={errors}
            action={onSubmit}
            cancel={cancelEdition}
            options={{ statesOptions: statesOptions }}
          />
        </div>
      </div>
    </>
  );
};

export const EditVehicularAsset = () => {
  let history = useHistory();
  let { vehicleId } = useParams();
  const { t } = useTranslation();
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [internalProvidersOptions, setInternalProvidersOptions] = useState([]);
  const [rcv, setRCV] = useState([]);
  const [propertyTitle, setPropertyTitle] = useState([]);
  const [preloadedCraneType, setPreloadedCraneType] = useState("");
  const vehicleClassesOptionsRef = useRef([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    watch,
  } = useForm({
    resolver: (data, context, options) =>
      yupResolver(
        schemas.CreateVehicularAssetSchema(t, vehicleClassesOptionsRef.current)
      )(data, context, options),
  });

  vehicleClassesOptionsRef.current = vehicleClassesOptions;

  const onSubmit = handleSubmit(async (data) => {
    delete data.date;
    delete data.provider

    const providersDrivers = selectedProviders.map(provider => provider._id);
    const dataToPost = {
      ...data,
      providersDrivers: providersDrivers,
    }

    if (!isCraneVehicleClass(filterOptionById(vehicleClassesOptions, dataToPost.class))) {
      delete dataToPost.type;
    }

    const formData = new FormData();

    for (const key in dataToPost) {
      if (Array.isArray(dataToPost[key])) {
        dataToPost[key].forEach((item, idx) => {
          formData.append(`${key}[${idx}]`, item);
        });
      } else if (dataToPost[key] !== undefined && dataToPost[key] !== null) {
        formData.append(key, dataToPost[key]);
      }
    }

    if (propertyTitle.length > 0) {
      formData.append("propertyTitle", propertyTitle[0]);
    }
    if (rcv.length > 0) {
      formData.append("rcv", rcv[0]);
    }


    if (!isLoading) {
      setIsloading(true);
      vehicularAssetsService
        .editVehicularAsset(formData, vehicleId)
        .then((response) => {
          if (response.status === 200) {
            notify(`Vehiculo editado con éxito`, "success");
            history.push("/fleet");
            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getVehicleClasses = () => {
    vehicleService
      .getVehicleClasses(true)
      .then((response) => {
        if (response.status === 200) {
          setVehicleClassesOptions(response?.data?.classes);
          getVehicleById(vehicleId);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const getVehicleBrands = async (classId) => {
    vehicleService
      .getVehicleBrands(classId)
      .then((response) => {
        if (response.status === 200) {
          setBrandOptions(response?.data?.vehicleBrands);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const getVehicleModels = async (brandId) => {
    vehicleService
      .getVehicleModels(brandId)
      .then((response) => {
        if (response.status === 200) {
          setModelOptions(response?.data?.models);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const getinternalProviders = (type) => {
    let params = {
      limit: 100,
      offset: 0,
      isInternal: true,
      type: type,
    };

    if (params.type === "GRÚA") {
      params.type = "Grua";
    } else if (params.type === "MOTO") {
      params.type = "Asistente Vial";
    } else {
      delete params.type;
    }

    providersService.getProvidersByType(params).then((response) => {
      if (response.status === 200) {
        response.data.providers.map((provider) => {
          return (provider.name = provider.contactName);
        });
        setInternalProvidersOptions(response.data.providers);
      } else {
        notify(`${response.message}` || "error", "error");
      }
    });
    return true;
  };


  const addProvider = () => {
    const provider = watch('provider');
    let providerData = internalProvidersOptions.find((p) => p._id === provider);

    if (selectedProviders.some((p) => p._id === providerData._id)) {
      notify("Proveedor ya se encuentra seleccionado", "info");
      setValue("provider", "");
      return;
    }
    setSelectedProviders([...selectedProviders, providerData]);
    setValue("provider", "");
  };

  const removeProvider = (index) => {
    setSelectedProviders((prev) => prev.filter((_, i) => i !== index));
  };

  const resolveCraneTypeValue = (value) => {
    if (!value) return "";
    const match = craneTypeOptions.find(
      (option) =>
        option._id === value ||
        option.name === value ||
        String(option._id).toLowerCase() === String(value).toLowerCase()
    );
    return match?._id || value;
  };

  const preloadForm = (vehicularAsset) => {
    getinternalProviders(vehicularAsset?.class?.name);
    const craneType = resolveCraneTypeValue(vehicularAsset?.type);
    setPreloadedCraneType(craneType);
    setTimeout(() => {
      setValue("class", vehicularAsset?.class?._id);
      setValue("brand", vehicularAsset?.brand?._id);
      setValue("model", vehicularAsset?.model?._id);
      setValue("plate", vehicularAsset?.plate);
      setValue("color", vehicularAsset?.color);
      if (vehicularAsset?.purchaseDate) {
        setValue("purchaseDate", new Date(vehicularAsset?.purchaseDate));
      }
      if (vehicularAsset?.alias) {
        setValue("alias", vehicularAsset?.alias);
      }
      setValue("year", vehicularAsset?.year);
      setValue("description", vehicularAsset?.description);
      setIsloading(false);
      setSelectedProviders(vehicularAsset?.providersDrivers);
    }, 2000);
  };

  const getVehicleById = async (vehicleId) => {
    vehicularAssetsService
      .getVehicleById(vehicleId)
      .then((response) => {
        if (response.status === 200) {
          getVehicleBrands(response?.data?.vehicularAsset?.class?._id)
            .then((brandId) => {
              getVehicleModels(response?.data?.vehicularAsset?.brand?._id);
            })
            .then((vehicularAsset) => {
              preloadForm(response?.data?.vehicularAsset);
            });
        } else {
          notify(`${response.message}` || "error", "error");
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  };


  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        if (
          !["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
            file.type
          )
        ) {
          notify(
            "Agregar un formato válido de imagen (PNG, JPG, JPEG)",
            "error"
          );
          return;
        }
        let maxWeight = 5; // MB
        if (file.size * 0.000001 > maxWeight) {
          notify(`La imagen no debe superar los ${maxWeight} MB`, "error");
          return;
        }
        else {
          let files = propertyTitle;
          files[0] = acceptedFiles[0];
          setPropertyTitle([...files]);
        }
      });
    },
    []
  );

  const onDrop2 = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        if (
          !["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
            file.type
          )
        ) {
          notify(
            "Agregar un formato válido de imagen (PNG, JPG, JPEG)",
            "error"
          );
          return;
        }

        let maxWeight = 5; // MB
        if (file.size * 0.000001 > maxWeight) {
          notify(`La imagen no debe superar los ${maxWeight} MB`, "error");
          return;
        }
        else {
          let files = rcv;
          files[0] = acceptedFiles[0];
          setRCV([...files]);
        }
      });
    },
    []
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const { getRootProps: getRootProps2, getInputProps: getInputProps2 } = useDropzone({ onDrop: onDrop2 });



  const cancelEdition = () => {
    history.push("/providers/external");
  };

  const handleVehicleType = () => {
    const classId = watch("class");
    const vehiCletype = filterOptionById(vehicleClassesOptions, classId);
    getinternalProviders(vehiCletype?.name);
    getVehicleBrands(classId);
    setSelectedProviders([]);
    if (!isCraneVehicleClass(vehiCletype)) {
      setValue("type", "");
    }
  };

  useState(() => {
    getVehicleClasses();
  }, []);

  const selectedClassId = watch("class");

  useEffect(() => {
    if (!preloadedCraneType || !selectedClassId) return;
    const selectedClass = filterOptionById(
      vehicleClassesOptions,
      selectedClassId
    );
    if (isCraneVehicleClass(selectedClass)) {
      setValue("type", preloadedCraneType);
    }
  }, [selectedClassId, preloadedCraneType, vehicleClassesOptions]);

  return (
    <>
      <Header />
      <LoadSpinner label={""} show={isLoading} />
      <div className="container">
        <div className="card incidence-card">
          <div style={{ margin: "0px" }} className="buttons-container">
            <h2 style={{ margin: "0px" }}>Editar Vehículo</h2>
          </div>
          <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
          <EditVehicularAssetForm
            t={t}
            register={register}
            errors={errors}
            action={onSubmit}
            options={{
              vehicleClassesOptions: vehicleClassesOptions,
              brandOptions: brandOptions,
              modelOptions: modelOptions,
              internalProvidersOptions: internalProvidersOptions,
              selectedProviders: selectedProviders,
            }}
            cancel={cancelEdition}
            control={control}
            watch={watch}
            onChange={{
              getVehicleBrands: getVehicleBrands,
              getVehicleModels: getVehicleModels,
              handleVehicleType: handleVehicleType,
              addProvider: addProvider,
              removeProvider: removeProvider,
            }}
            getRootProps={getRootProps}
            getInputProps={getInputProps}
            getRootProps2={getRootProps2}
            getInputProps2={getInputProps2}
            propertyTitle={propertyTitle}
            rcv={rcv}
          />
        </div>
      </div>
    </>
  );
};
